export class HereCredentials {
    expiry: string;
    type: string;
    constructor(public appId = '', public appCode = '', public apiKey = '') {
    }
}
